export const getActiveGoalPortfolios = <T extends { archived: boolean }>(
	portfolios: T[],
): T[] => portfolios.filter((portfolio) => !portfolio.archived);
